import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface AuthState {

    ////////////////////////////////////////////////////////////// 상태

    isLoggedIn: boolean;
    isAdmin: boolean;
    isGuest: boolean;
  
    ////////////////////////////////////////////////////////////// 액션

    setIsLoggedIn: (isLoggedIn: boolean) => void;
    setIsAdmin: (isAdmin: boolean) => void;
    setIsGuest: (isGuest: boolean) => void;
}

export const useAuthStore = create<AuthState>()(
    persist(
        (set) => ({

            ////////////////////////////////////////////////////////////// 초기 상태

            isLoggedIn: false as boolean,
            isAdmin: false as boolean,
            isGuest: false as boolean,

            ////////////////////////////////////////////////////////////// 액션

            setIsLoggedIn: (isLoggedIn: boolean) => set({ isLoggedIn }),
            setIsAdmin: (isAdmin: boolean) => set({ isAdmin }),
            setIsGuest: (isGuest: boolean) => set({ isGuest }),

        }),
        {
            name: "auth-store",

            ////////////////////////////////////////////////////////////// 부분 상태 저장

            partialize: (state: AuthState) => ({ 
                isLoggedIn: state.isLoggedIn, 
                isAdmin: state.isAdmin,
                isGuest: state.isGuest,
            }),
            
        }
    ) 
);